import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'jow-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ButtonComponent {

  @Input() size: 'default' | 'small' = 'default';
  @Input() theme: 'primary' | 'secondary' = 'primary';
  @Input() type: 'button' | 'submit' = 'button'; 
  @Input() @HostBinding('class.disabled') disabled: boolean;
}
